export default __webpack_public_path__ + "static/media/homer-simpsons-monkey.6722e5e4.gif";